import {AppConfig} from '../../../../../types';

export const validateImageFile = (
  file: File,
  imageUploadLimits: AppConfig['searchForm']['imageUploadLimits']
) =>
  new Promise<string | null>((resolve) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);

    image.onload = function imageOnLoadCb() {
      const {minHeight, minWidth, sizeMax, sizeMin} = imageUploadLimits;
      const imageWidth = this.width;
      const imageHeight = this.height;
      URL.revokeObjectURL(objectUrl);

      // check empty size
      if (file.size === 0) {
        return resolve('File seems to be broken. Please select valid image file.');
      }

      // check min size
      if (file.size < sizeMin * 1024) {
        return resolve(`File is too small. Please select file with size minimum of ${sizeMin}Kb.`);
      }
      // check max size
      if (file.size > sizeMax * 1048576) {
        return resolve(`File is too big. Please select file with size maximum of ${sizeMax}Mb.`);
      }

      // check dimensions
      if (imageWidth < minWidth) {
        return resolve(
          `File has incorrect width. Please select file with minimum width of ${minWidth} pixels.`
        );
      }
      if (imageHeight < minHeight) {
        return resolve(
          `File has incorrect height. Please select file with minimum height of ${minHeight} pixels.`
        );
      }
      resolve(null);
    };

    image.src = objectUrl;
  });
